export const environment = {
  api_endpoints: {
    absences: '/absences/:id/:year',
    absencesCreateUpdate: '/absences/:id',
    appointment: '/appointments/:id',
    appointmentFromQR: '/appointments/:id',
    appointmentProcessed: '/appointments-scanned/processed/:id',
    appointmentScanQR: '/appointments/:id/fromImageQR',
    appointments: '/appointments/byperiod/:freq/:start',
    appointmentsPatient: '/appointments/bypatient/:id',
    appointmentsScanned: '/appointments-scanned/:date',
    auth: '/auth',
    auths: '/auths',
    customers: '/customers',
    customersWithProducts: '/customersWithProducts',
    employees: '/auths',
    employeesOccupancy: '/professionals/occupancy',
    employeesSchedule: '/auths/simple',
    features: '/tenants/anonymous-features/:name',
    file: '/tenants/anonymous-file',
    invoices: '/invoices',
    login: '/login',
    medicalRecord: '/patients/:id/medical-records',
    medicalRecordDocDownload: '/medical-records/:id/document/:idDoc',
    medicalRecordOpen: '/patients/:idPatient/medical-records/:id/open',
    medicalRecordSchedules: '/schedules/patient/:idPatient/medical-record/:id',
    meeting: '/meetings',
    meetings: '/meetings/:freq/:start',
    passwordChange: '/login/password',
    passwordChangeEmployee: '/auths/password/:id',
    passwordRecover: '/login/forgotten',
    patients: '/patients',
    payments: '/payments',
    products: '/products',
    quotes: '/quotes',
    quotesSettle: '/quotes-settlements',
    refreshToken: '/login/expiration',
    schedules: '/schedules/:id',
    schedulesAuthCode: '/schedules/authorizationCode',
    schedulesCreateUpdate: '/schedules/patient/:idPatient/medical-record/:id',
    tenants: '/tenants',
    timesheets: '/timesheets/:id',
    timetrack: '/timetrack/:freq/:start',
    vacations: '/vacations/:id/:year',
    vacationsConfirm: '/vacations/confirm/:id',
    vacationsDuration: '/vacations/duration/:id/:year/:begin/:end',
    vacationsReject: '/vacations/refuse/:id',
    vacationsRequest: '/vacations/:id',
  },
  api_server: 'https://benefit-api-dev.talentosoftware.com', // dev
  // api_server: 'https://benefit-api.grupofisioclinicas.es',  // prod
  cardholderDiscount: 15,
  currencies: {
    EUR: {
      icon: 'pi-euro',
      text: '€'
    },
    USD: {
      icon: 'pi-dollar',
      text: '$'
    },
  },
  docs: {
    billing: false, // quotes && invoices
    employee: false, // employees && timesheets
    patient: false, // patients && medical records
  },
  forbiddenCustomerNames: ['generic', 'generic_foot'],
  logLevel: 1,
  noPaymentMethod: '-none-',
  pattern: {
    phone: '^[6789][0-9]{8}$',
    quotes: /"(.*?)"/g
  },
  production: false,
  qrReader: {
    tera: 'TERA', // qr reader (TERA)
    webcam: 'WEBCAM', // laptop cam (WEBCAM)
  },
  recentPatientsSince: 180, // days from now
  section: {
    patients: true,
  },
  tokenExpires: 300, // seconds
  vacations: {
    defaultDays: 31,
    defaultType: 'natural',
    limitYear: 2025, // included
  },
  wacom: {
    licenseKey: '15703424-451e-4e31-8922-3f92fa2f47e4',
    licenseSecret: 'sc+be9UdH+DLGW1mQtI+zpOMKqp5WWs2ITpDjDlJRa/UgS1ObeCGDNfIxioi8bwRGg58OnY0QzKIDJbr9NcoxA==',
    mouse: true, // sign with mouse vs tablet
  },
};
